import { render } from "./ProductsBlock.vue?vue&type=template&id=6e29a295&scoped=true"
import script from "./ProductsBlock.vue?vue&type=script&lang=js"
export * from "./ProductsBlock.vue?vue&type=script&lang=js"

import "./ProductsBlock.vue?vue&type=style&index=0&id=6e29a295&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e29a295"]])

export default __exports__